import { ArticleVoteParams } from "../../shared/types";
import { internals } from "../internal"

export const articles = {
  web: {
    subdomain: window.location.host,
    locale: window.location.pathname.split("/")[2]
  },

  general: {
    perPage: "100",
    include: "categories,sections"
  },

  async getAll(page: number = 1) {
    const storageName = `${this.web.subdomain}-articles-p${page}`;
    if (sessionStorage.getItem(storageName)) { return JSON.parse(sessionStorage.getItem(storageName) as string); }

    const response = await fetch(
      `/api/v2/help_center/${this.web.locale}/articles?per_page=${this.general.perPage}&include=${this.general.include}`,
    );

    const json = await response.json();

    while (json.next_page) {
      const nextResult = await fetch(json.next_page);
      const nextJson = await nextResult.json();

      json.categories.push(...nextJson.categories
        .filter((nextCategory: any) =>
          json.categories
            .findIndex((category: any) => category.id === nextCategory.id) === -1
        )
      );
      json.sections.push(...nextJson.sections
        .filter((nextSection: any) =>
          json.sections
            .findIndex((section: any) => section.id === nextSection.id) === -1
        )
      );
      json.articles = json.articles.concat(nextJson.articles);
      json.next_page = nextJson.next_page;
    }

    sessionStorage.setItem(storageName, JSON.stringify(json));
    return json
  },

   async searchArticle(query: string) {
    const MAX_PAGES = 50;
    const REQUEST_TIMEOUT = 8000;
    const fetchWithTimeout = (url: string, options = {}) => {
      return Promise.race([
        fetch(url, options),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Request timeout")), REQUEST_TIMEOUT)
        )
      ]);
    };

    try {
      if (!query || typeof query !== "string") {
        return { results: [], count: 0 };
      }
      const encoded = encodeURIComponent(query);
      let url = `/api/v2/help_center/articles/search.json?query=${encoded}`;
      let json = {
        results: [],
        next_page: url
      };

      let pageCount = 0;

      while (json.next_page) {
        if (pageCount > MAX_PAGES) {
          break;
        }

        const response = await fetchWithTimeout(json.next_page) as Response;

        if (!response.ok) break;


        const data = await response.json();
        if (!Array.isArray(data.results)) {
          break;
        }
        json.results = json.results.concat(data.results);
        json.next_page = data.next_page;

        pageCount++;
      }

      return json;

    } catch (error: any) {
      return { results: [], error: error.message };
    }
  },

  async vote({ articleId, vote }: ArticleVoteParams) {
    const sessionVotes = JSON.parse(sessionStorage.getItem('cur-votes') ?? '') || {};
    if (!['up', 'down'].includes(vote)) throw new Error(`Tipo de voto "${vote}" inválido`);
    try {
      const baseURL = `/api/v2/help_center/pt-br/articles/${articleId}/${vote}`;
      const response = await fetch(
        baseURL,
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            'x-csrf-token': await internals.getAuthorizationToken(),
            'x-requested-with': 'XMLHttpRequest',
          },

        }
      );

      if (!response.ok) {
        throw {
          message: 'A API do Zendesk retornou um erro inesperado, tente novamente. Caso o erro persista, nos informe através de uma solicitação',
          code: response.status
        }
      };

      sessionVotes[articleId] = vote;
      sessionStorage.setItem('cur-votes', JSON.stringify(sessionVotes));

      return response.json();
    } catch (error: any) {
      return {
        error: true,
        message: `Ocorreu um erro ao votar no artigo de ID "${articleId}"`,
        originalError: `${error.code} - ${error.message}`
      }
    }
  }
}